import { render, staticRenderFns } from "./DisplayHintsListDialog.vue?vue&type=template&id=878fdc76&"
import script from "./DisplayHintsListDialog.vue?vue&type=script&lang=ts&"
export * from "./DisplayHintsListDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports